import React from 'react'

const Backdrop = ({ sidebar, close }) => {
    return (
        <div className={`fixed top-0 left-0 w-full h-screen z-20 bg-slate-100 ${sidebar ? 'block' : 'hidden'} opacity-50 md:hidden`} onClick={close}></div>
    )
}

export default Backdrop